/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';

import dynamic from 'next/dynamic';
import { Rating } from 'react-simple-star-rating';
import getTimeAgo from '../../utils/getDateTime';
import { useMediaQuery } from '../../hooks/mediaQuery';
import { Attraction, BestReview } from '../../types/pages/tour';
import { City } from '../../types/pages/things-to-do';
const DateAndPax = dynamic(() => import('../CalendarAndPax/DateAndPax'));

type INCLUDED = {
  data: string[];
  attractions?: Attraction[];
  longDescription: string;
  rezdyId: string;
  reviewState: {
    average: number;
    total: number;
  };
  bestReview: BestReview | undefined;
  updateTourContext: () => void;
  duration: number;
  privateTour: boolean;
  tourId: string;
  adult: number | null;
  infant: number | null;
  child: number | null;
  name: string;
  slug?: string;
  shortDescription: string;
  city?: City | undefined;
  bookingCutOffTime: string | null;
  showPax?: boolean;
};

const Included = ({
  rezdyId,
  updateTourContext,
  privateTour,
  tourId,
  adult,
  infant,
  child,
  name,
  bestReview,
  city,
  slug,
  showPax
}: INCLUDED) => {
  const ref = useRef(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [stopPosition, setStopPosition] = useState<number>(0);
  const mediaQuery = useMediaQuery(944);
  useEffect(() => {
    if (containerRef.current) {
      const containerHeight = containerRef.current.offsetHeight;
      const stopPosition = containerHeight - 900;

      setStopPosition(stopPosition);
    }
  }, []);

  return (
    <>
      <div className="w-[380px]">
        <div className="sm:block md:flex mmd:block">
          <div className="mmd:p-3 mmd:mb-[30px] rounded-lg shadow-none mmd:shadow-xl">
            <DateAndPax
              rezdyId={rezdyId}
              updateTourContext={updateTourContext}
              mobile={false}
              privateTour={privateTour}
              tourId={tourId}
              adult={adult}
              child={child}
              infant={infant}
              name={name}
              slug={slug}
              bestReview={bestReview}
              city={city?.name}
            />
          </div>
          {bestReview && (
            <div className="h-full flex-col items-start justify-center mb-4 xxsm:hidden lg:flex ">
              <div className="flex flex-col relative opacity-80 text-white rounded-lg">
                <Image
                  src="/quote.png"
                  width={30}
                  height={38}
                  alt=""
                  className="w-[20px] "
                />
                <div
                  className={`px-6 mb-1 ${
                    bestReview.review.length > 300
                      ? 'min-h-[450px]'
                      : 'min-h-[250px]'
                  }`}
                >
                  <p className="text-base lg:text-lg font-bold text-black">
                    {bestReview.name}
                  </p>
                  <div className="flex gap-3 text-black font-bold">
                    <Rating
                      initialValue={5}
                      disableFillHover={true}
                      fillColor="orange"
                      emptyColor="#9B9B9B"
                      readonly={true}
                      SVGstyle={{
                        display: 'inline-block'
                      }}
                      size={15}
                    />
                    {getTimeAgo(bestReview?.created_at)}
                  </div>
                  <div className="flex">
                    <p className="text-sm max-h-[100px] sm:text-[15px] text xl:text-[16px] font-[400 mt-3] text-black">
                      <span style={{ display: 'inline-block' }}>
                        {bestReview?.review}
                        <Image
                          src="/quote.png"
                          width={30}
                          height={38}
                          alt=""
                          className="w-[20px] mt-4"
                          style={{ display: 'inline-block' }}
                        />
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className=" w-[30px] h-[30px] absolute bottom-[3] left-8 z-30"></div>
            </div>
          )}
        </div>

        {showPax && (
          <div className={`py-4 w-full bg px-2 bg-white`}>
            <DateAndPax
              rezdyId={rezdyId}
              updateTourContext={updateTourContext}
              mobile={true}
              privateTour={privateTour}
              tourId={tourId}
              adult={adult}
              child={child}
              infant={infant}
              name={name}
              slug={slug}
              bestReview={bestReview}
              city={city?.name}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Included;
